/*
 * @Description: 路由页面
 * @Author: jin
 * @Date: 2019-10-14 11:31:04
 */
import Vue from 'vue'
import Router from 'vue-router'
import { toast } from '../util'

Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/',
      component: resolve => require(['../pages/home/home'], resolve),
      children: [
        {
          path: '',
          name: '/',
          component: resolve => require(['../pages/home/components/homeMian'], resolve)
        },
        {
          path: 'home',
          name: 'home',
          component: resolve => require(['../pages/home/components/homeMian'], resolve)
        },
        {
          path: 'query',
          name: 'query',
          component: resolve => require(['../pages/query'], resolve)
        },
        {
          path: 'queryDetial/:id',
          name: 'queryDetial',
          component: resolve => require(['../pages/queryDetial'], resolve)
        },
        {
          path: 'origin',
          name: 'origin',
          component: resolve => require(['../pages/origin'], resolve)
        },
        {
          path: 'culture',
          name: 'culture',
          component: resolve => require(['../pages/culture'], resolve)
        },
        {
          path: 'scenery',
          name: 'scenery',
          component: resolve => require(['../pages/scenery'], resolve)
        },
        {
          path: 'hall',
          name: 'hall',
          component: resolve => require(['../pages/hall'], resolve)
        },
        {
          path: 'msg',
          name: 'msg',
          component: resolve => require(['../pages/msg'], resolve)
        },
        {
          path: 'addMsg',
          name: 'addMsg',
          component: resolve => require(['../pages/msg/addMsg'], resolve)
        },
        {
          path: 'article/:id',
          name: 'article',
          component: resolve => require(['../pages/article'], resolve)
        },
        {
          path: 'login',
          name: 'login',
          component: resolve => require(['../pages/login'], resolve)
        },
        {
          path: 'register',
          name: 'register',
          component: resolve => require(['../pages/register'], resolve)
        },
        {
          path: 'retrievePass',
          name: 'retrievePass',
          component: resolve => require(['../pages/retrievePass'], resolve)
        },
        {
          path: 'userInfo',
          name: 'userInfo',
          component: resolve => require(['../pages/userInfo'], resolve)
        },
        {
          path: 'test',
          name: 'test',
          component: resolve => require(['../pages/myTest'], resolve)
        },
        {
          path: 'contact',
          name: 'contact',
          component: resolve => require(['../pages/contact'], resolve)
        }
      ]
    }
  ]
})
/* router.beforeEach((to, from, next) => {
  if (to.name == 'query') {
    toast('正在完善，暂未开放')
    next(home)
  }
}) */
export default router



// WEBPACK FOOTER //
// ./src/router/index.js